import type { ChatRequest, SSEEvent } from './types';
import { consumeSseStream } from '../streaming/sseConsumer';

export async function* streamOpenAIChat(req: ChatRequest): AsyncGenerator<SSEEvent> {
  const resp = await fetch('/api/chat/openai', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(req),
  });
  if (!resp.ok || !resp.body) {
    const msg = await resp.text();
    throw Object.assign(new Error(msg || `HTTP ${resp.status}`), {
      status: resp.status,
      code: 'http-error',
    });
  }
  yield* consumeSseStream(resp.body);
}
